import { render, staticRenderFns } from "./send-record.vue?vue&type=template&id=62c3baf0"
import script from "./send-record.vue?vue&type=script&lang=ts"
export * from "./send-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports